setTimeout(function () {
  $('body').addClass('is-transition');
}, 10);